<template>
    <div class="transfer-dialog">
        <el-dialog
            :visible="transferVisible"
            width="500px"
            title="转办"
            destroy-on-close
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            @close="handleClose">
            <dc-form ref='dcForm' refName="transferForm" :row="formData" :config="FIELDS"
                :col="1" @data-changed="handleFormDataChange"
                labelWidth="100px" class="transfer-form">
            </dc-form>
            <span slot="footer">
                <el-button size="mini" @click="handleClose">取 消</el-button>
                <lots-button type="primary" size="mini" @click="handleConfirm" :loading="confirmLoading">确 认</lots-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import { tableConfig } from './config.js';
export default {
    components: {
        lotsButton,
        dcForm
    },
    props: {},
    setup(props, setupContext) {
        const { emit } = setupContext;
        const formData = ref({
            ownerName: '',
            ownerCode: ''
        });
        const transferVisible = ref(false);
        const confirmLoading = ref(false);
        const config = reactive(tableConfig);
        const FIELDS = computed(() => {
            return config.fields;
        });
        const handleConfirm = () => {
            setupContext.refs.dcForm.$refs.transferForm.validate((valid) => {
                if (valid) {
                    emit('confirm', formData.value);
                }
            });
        };
        const handleFormDataChange = ({ data, form, itemSetting }) => {
            formData.value = Object.assign(formData.value, form);
        };
        const show = () => {
            setupContext.root.$nextTick(() => {
                transferVisible.value = true;
                formData.value = {
                    ownerName: '',
                    ownerCode: ''
                };
            });
        };
        const handleClose = () => {
            transferVisible.value = false;
            formData.value = {
                ownerName: '',
                ownerCode: ''
            };
        };
        return {
            transferVisible,
            formData,
            FIELDS,
            confirmLoading,
            handleFormDataChange,
            handleConfirm,
            handleClose,
            show
        };
    }
};
</script>
<style lang="less">
.transfer-dialog {
    .transfer-form {
        .el-form-item {
            margin-bottom: 20px;
        }
    }
}
</style>
